import React from 'react';
import { VoteIcon, UserIcon, CheckSquareIcon } from 'lucide-react';
const officerCandidates = [{
  position: 'President',
  candidates: ['Chip Marks']
}, {
  position: 'Vice President of Operations',
  candidates: ['Andy Shute']
}, {
  position: 'Vice President of Marketing',
  candidates: ['Jeff Lane']
}, {
  position: 'Vice President of Finance',
  candidates: ['Paul Hales']
}];
const boardCandidates = ['Larry Andrykovich', 'Brian Swanson', 'Jason Hartell'];
export function ElectionBallot() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-1338">
      <div className="max-w-4xl mx-auto px-4 md:px-8 pt-10" data-id="element-1339">
        <div className="bg-white rounded-xl overflow-hidden shadow-sm border" style={{
        borderColor: '#ede9e0'
      }} data-id="element-1340">
          <div className="p-4 flex items-center gap-3" style={{
          backgroundColor: '#1e3d2f'
        }} data-id="element-1341">
            <VoteIcon size={20} style={{
            color: '#c8a84b'
          }} data-id="element-1342" />
            <h2 className="text-base font-bold uppercase" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#ffffff'
          }} data-id="element-1343">
              January 2026 Election Ballot
            </h2>
          </div>
          <div className="p-6 md:p-8" data-id="element-1344">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1345">
              {/* Officers - 1 Year Term */}
              <div data-id="element-1346">
                <h3 className="text-lg font-bold uppercase mb-5 pb-3 border-b" style={{
                fontFamily: 'Oswald, sans-serif',
                color: '#1e3d2f',
                borderColor: '#ede9e0'
              }} data-id="element-1347">
                  Officers — 1 Year Term
                </h3>
                <div className="space-y-5" data-id="element-1348">
                  {officerCandidates.map(office => <div key={office.position} data-id="element-1349">
                      <h4 className="text-sm font-bold uppercase tracking-wider mb-2" style={{
                    color: '#c8a84b',
                    fontFamily: 'Inter, sans-serif'
                  }} data-id="element-1350">
                        {office.position}
                      </h4>
                      <div className="space-y-2" data-id="element-1351">
                        {office.candidates.map(candidate => <div key={candidate} className="flex items-center gap-3 p-3 rounded-lg" style={{
                      backgroundColor: 'rgba(30,61,47,0.04)'
                    }} data-id="element-1352">
                            <UserIcon size={18} style={{
                        color: '#1e3d2f'
                      }} data-id="element-1353" />
                            <span className="text-base font-semibold" style={{
                        color: '#1e3d2f',
                        fontFamily: 'Inter, sans-serif'
                      }} data-id="element-1354">
                              {candidate}
                            </span>
                          </div>)}
                        <div className="flex items-center gap-3 p-3 rounded-lg border border-dashed" style={{
                      borderColor: '#d0ccc3'
                    }} data-id="element-1355">
                          <CheckSquareIcon size={18} style={{
                        color: '#999'
                      }} data-id="element-1356" />
                          <span className="text-sm text-gray-400 italic" style={{
                        fontFamily: 'Inter, sans-serif'
                      }} data-id="element-1357">
                            Write-in candidate
                          </span>
                        </div>
                      </div>
                    </div>)}
                </div>
              </div>

              {/* Board of Directors - 2 Year Term */}
              <div data-id="element-1358">
                <h3 className="text-lg font-bold uppercase mb-5 pb-3 border-b" style={{
                fontFamily: 'Oswald, sans-serif',
                color: '#1e3d2f',
                borderColor: '#ede9e0'
              }} data-id="element-1359">
                  Board of Directors — 2 Year Term
                </h3>
                <p className="text-sm text-gray-500 mb-4" style={{
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-1360">
                  (Vote for 3 Only)
                </p>
                <div className="space-y-2" data-id="element-1361">
                  {boardCandidates.map(candidate => <div key={candidate} className="flex items-center gap-3 p-3 rounded-lg" style={{
                  backgroundColor: 'rgba(30,61,47,0.04)'
                }} data-id="element-1362">
                      <UserIcon size={18} style={{
                    color: '#1e3d2f'
                  }} data-id="element-1363" />
                      <span className="text-base font-semibold" style={{
                    color: '#1e3d2f',
                    fontFamily: 'Inter, sans-serif'
                  }} data-id="element-1364">
                        {candidate}
                      </span>
                    </div>)}
                  {[1, 2, 3].map(i => <div key={i} className="flex items-center gap-3 p-3 rounded-lg border border-dashed" style={{
                  borderColor: '#d0ccc3'
                }} data-id="element-1365">
                      <CheckSquareIcon size={18} style={{
                    color: '#999'
                  }} data-id="element-1366" />
                      <span className="text-sm text-gray-400 italic" style={{
                    fontFamily: 'Inter, sans-serif'
                  }} data-id="element-1367">
                        Write-in candidate
                      </span>
                    </div>)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}